/**
 * Page component module.
 * @module shared/components/Page
 */
import React from 'react';
import PropTypes from 'prop-types';
import './pages.css';
import styled from 'styled-components/macro';

const _Children = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: ${(props) => props.center ? 'center' : 'flex-start'};
  width: 100%;
  //noinspection CssInvalidPropertyValue
  height: -moz-fit-content;
  height: fit-content;
  ${props => props.minHeight && `min-height: ${props.minHeight}`};
`;

const _PageBase = styled.div`
  background-image: url(${(props) => props.backgroundImage});
  background-size: cover;
  ${props => props.minHeight && `min-height: ${props.minHeight}`};
  //width: 100vw;
  // min-height: 100vh;
  //max-height: 100%;
  //position: fixed;
  //left: 0;
  display: flex;
  flex-direction: column;
  //overflow-y: auto;
`;
/**
 * Page component to serve as container for all other components/modules.
 * @name Page
 */
const Page = ({backgroundImage, className, center, minHeight, title, children}) => <_PageBase backgroundImage={backgroundImage}
                                                                                              className={className}
                                                                                              minHeight={minHeight}>
  {title && <h1 className='page-title'>{title}</h1>}
  <_Children center={center} minHeight={minHeight}>
    {children}
  </_Children>
</_PageBase>;

export default Page;
Page.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  backgroundImage: PropTypes.string,
  className: PropTypes.string,
  /**
   * Optional whether this tile needs to be centered
   */
  center: PropTypes.bool,
  /**
   * min-height of the page
   */
  minHeight: PropTypes.string,
};
